import * as z from 'zod';
import { passwordSchema } from '../utils/validators/passwordSchema.ts';
export const resetPasswordSchema = z.object({
  password: passwordSchema,
});

export type ResetPasswordRequest = z.infer<typeof resetPasswordSchema>;
